import { mergeStyleSets } from '@fluentui/react';
import { ITheme } from '@theme/foundations';

const getStyles = (theme: ITheme) =>
  mergeStyleSets({
    modalWrapper: {
      width: '100%',
      height: '100vh',
    },
    contentContainer: {
      width: '100%',
      display: 'inline',
    },
    modalContainer: {
      padding: '30px',
    },
  });

export default getStyles;
